import React, { FC } from 'react';

import { DecisionHeaderSubtitle } from '../../../../decision/header/DecisionHeaderSubtitle';
import { DecisionHeaderTitle } from '../../../../decision/header/DecisionHeaderTitle';
import { SearchDecision } from '../../../../decision/decision.types';
import { addNewPositionToUrl } from '../../../../decision/decisionUtils';
import { getPageName } from '../../../../utils/pageName';

type Props = {
  index?: number;
  decision: SearchDecision;
  source: string;
  additionalQueryParams?: { [s: string]: string } | null;
};

export const DecisionSearchHeader: FC<Props> = ({
  decision,
  index = 0,
  source,
  additionalQueryParams,
}) => {
  const onDecisionTitleClicked = () => {
    const position = typeof index !== 'undefined' ? index : 0;
    addNewPositionToUrl(position);
  };
  const pageName = getPageName();

  return (
    <>
      <DecisionHeaderTitle
        decision={decision}
        index={index}
        source={source}
        sourcePage={pageName}
        onDecisionTitleClicked={onDecisionTitleClicked}
        additionalQueryParams={additionalQueryParams}
      />
      <DecisionHeaderSubtitle
        arretDecAtt={decision.arretDecAtt}
        solution={decision.solution}
        validation={decision.validation}
        docId={decision.docId}
        automaticMetadata={decision.automaticMetadata}
        source={source}
      />
    </>
  );
};
